<template>
  <div class="wx-qrcode-overlay">
    <van-overlay
      :show="value"
    >
      <van-icon
        name="cross"
        class="close"
        @click="$emit('change', false)"
      />
      <div class="code-wrapper">
        <vue-qr
          :margin="10"
          :size="200"
          :text="qrcode"
        />
        <van-button class="go-button" @click="clickHandler">已完成支付</van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'WxQrcodeOverlay',
  components: { VueQr },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    qrcode: {
      type: [String],
      default: ''
    }
  },
  methods: {
    clickHandler () {
      this.$emit('change', false)
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.wx-qrcode-overlay {
  position: relative;
  .close {
    @include sc(28px, $color-text-light);
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .code-wrapper {
    @include wh(200px, 200px);
    margin: 200px auto;
    text-align: center;
    .go-button {
      @include normal-button(100%, 39px);
      @include lg-radius(#E6AC67, #F5C993, 4px);
      margin-top: 200px;
      font-size: $font-size-lg;
    }
  }
}
</style>
